'use client';

import { ReactNode, useCallback } from 'react';
import { observer } from 'mobx-react-lite';
import { Link, useLocation } from 'react-router-dom';
import { Group, MantineSpacing, Text, UnstyledButton } from '@mantine/core';
import { useStore } from '@/stores';
import { Icon, IconName } from '@/ui/Icon';
import classes from './NavbarButton.module.css';

export const NavbarButton = observer(
  ({
    label,
    icon,
    href,
    rightSection,
    h,
    pl,
    exact = true,
  }: {
    label: string;
    icon?: IconName | ReactNode;
    href?: string;
    rightSection?: ReactNode;
    h?: number;
    pl?: MantineSpacing;
    exact?: boolean;
  }) => {
    const location = useLocation();
    const store = useStore();
    const pathname = location.pathname;

    const isIcon = typeof icon === 'string';

    const isActive = href ? (exact ? pathname === href : pathname.startsWith(href)) : false;

    const onClick = useCallback(() => {
      if (store.isMobile) {
        store.navbar.toggle();
      }
    }, [store]);

    if (href) {
      return (
        <UnstyledButton
          component={Link}
          to={href}
          className={classes.navbarButton}
          variant="subtle-darker"
          data-active={isActive ? true : undefined}
          h={h}
          pl={pl}
          onClick={onClick}
        >
          <Group gap="xs" justify="space-between" w="100%">
            <Group gap="2xs" align="center" wrap="nowrap">
              {typeof icon === 'string' ? (
                <Icon name={icon as IconName} p={0} color="var(--mantine-color-text)" />
              ) : (
                icon
              )}
              <Text size="sm" fw={400}>
                {label}
              </Text>
            </Group>
            {rightSection}
          </Group>
        </UnstyledButton>
      );
    }

    return (
      <UnstyledButton
        className={classes.navbarButton}
        variant="subtle-darker"
        data-active={isActive ? true : undefined}
        h={h}
        onClick={onClick}
      >
        <Group gap="xs" justify="space-between" w="100%">
          <Group gap="2xs" align={isIcon ? 'center' : 'baseline'} wrap="nowrap">
            {typeof icon === 'string' ? <Icon name={icon as IconName} p={0} /> : icon}
            <Text size="sm" fw={400}>
              {label}
            </Text>
          </Group>
          {rightSection}
        </Group>
      </UnstyledButton>
    );
  }
);
